import React, { useState } from 'react';
import clsx from 'clsx';

const Accordion = ({ title, children, filterCount = 0, open = false, className = '' }) => {
    const [isOpen, setIsOpen] = useState(open);

    return (
        <div className={clsx('accordion ' + (isOpen ? 'show' : ''), className)}>
            <div className="accordion--header" onClick={() => setIsOpen(!isOpen)} {...(filterCount ? {'data-filter-count': filterCount} : {})}>
                {title}
            </div>
            {isOpen && <div className="accordion--collapsible">
                <div className="accordion--content">
                    {children}
                </div>
            </div>}
        </div>
    );
};

export default Accordion;